module.exports = __webpack_public_path__ + "d9206f4238977a6fe7b93f4478372337.pdf";